import EventEmitter from "../utils/EventEmitter";

export default class AccordionFilters extends EventEmitter {
    constructor(element) {
        super();
        this.el = element

        this.header = this.el.querySelector('.accordion-header')
        this.content = this.el.querySelector('.accordion-content')
        this.contentInner = this.content.querySelector('div')
        this.checkboxs = this.el.querySelectorAll('.js-form-type-checkbox')
        this.viewMoreBtn = this.el.querySelector('.accordion-more-btn')
        this.icon = this.header.querySelector('.icon')

        // Get the 5 first checkboxes and get the total height
        this.checkboxHeight = 0
        this.checkboxs.forEach((item, index) => {
            if (index < 5) {
                this.checkboxHeight += item.scrollHeight + 10
            }
        })


        if (this.checkboxs.length === 0) {
            this.el.style.display = 'none'
        }
        this.close()
        this.events()
    }

    events() {
        this.viewMoreBtn.addEventListener('click', () => {
            if (this.el.classList.contains('is-open')) {
                this.close()
            } else {
                this.open()
            }
        })

        this.header.addEventListener('click', () => {
            if (this.el.classList.contains('is-open')) {
                this.close()
            } else {
                this.open()
            }
        })
    }

    open() {
        this.content.style.height = `${this.contentInner.scrollHeight}px`
        this.el.classList.add('is-open')

        this.viewMoreBtn.style.display = 'block'
        this.viewMoreBtn.querySelector('p').innerHTML = this.viewMoreBtn.dataset.less
    }

    close() {

        if (this.checkboxs.length <= 5) {
            this.viewMoreBtn.style.display = 'none'
            this.icon.style.display = 'none'
            return
        }

        this.content.style.height = `${this.checkboxHeight}px`
        this.el.classList.remove('is-open')

        this.viewMoreBtn.style.display = 'block'
        this.viewMoreBtn.querySelector('p').innerHTML = this.viewMoreBtn.dataset.more
    }

    updateHeight() {
        this.content.style.height = `${this.contentInner.scrollHeight}px`
        this.viewMoreBtn.style.display = 'none'
    }

    destroy() {
        this.viewMoreBtn.removeEventListener('click', () => {
            if (this.el.classList.contains('is-open')) {
                this.close()
            } else {
                this.open()
            }
        })

        this.header.removeEventListener('click', () => {
            if (this.el.classList.contains('is-open')) {
                this.close()
            } else {
                this.open()
            }
        })
    }

}
